import { Component, input } from "@angular/core";

@Component({
  selector: "app-color-ramp",
  templateUrl: "./color-ramp.component.html",
  styleUrl: "./color-ramp.component.scss"
})
export class ColorRampComponent {
  readonly colors = input<string[]>([]);
  readonly minValue = input<string | undefined>();
  readonly maxValue = input<string | undefined>();
}
